// Mecanismo de dark mode: por padrão segue a preferência do sistema
// (@media prefers-color-scheme em theme/brands/*.css). O usuário pode forçar
// um modo específico via setThemeMode(); a escolha persiste em localStorage.
//
// Não há toggle na UI ainda — isso é decisão de produto/UX (onde colocar o
// botão) que fica para uma etapa separada. `initTheme()` já deixa o sistema
// funcionando (auto, via SO) e `setThemeMode` pronto para um futuro toggle.
//
// Pra visualizar/testar sem esperar esse toggle: ?theme=dark, ?theme=light
// ou ?theme=system na URL — força o modo e persiste (sobrevive à navegação
// da SPA e a reloads seguintes, até trocar de novo ou passar ?theme=system).

const STORAGE_KEY = 'theme-mode'; // 'light' | 'dark' | 'system' — nome genérico (agnóstico de marca)

export function setThemeMode(mode) {
  if (mode === 'system') {
    localStorage.removeItem(STORAGE_KEY);
    delete document.documentElement.dataset.theme;
  } else {
    localStorage.setItem(STORAGE_KEY, mode);
    document.documentElement.dataset.theme = mode;
  }
}

export function getThemeMode() {
  return localStorage.getItem(STORAGE_KEY) || 'system';
}

// Chamado uma vez, o mais cedo possível (antes do primeiro paint), pra
// aplicar a preferência manual salva (ou o override por querystring) sem
// esperar o React montar.
export function initTheme() {
  const forced = new URLSearchParams(location.search).get('theme');
  if (forced === 'light' || forced === 'dark' || forced === 'system') {
    setThemeMode(forced);
    return;
  }
  const saved = localStorage.getItem(STORAGE_KEY);
  if (saved === 'light' || saved === 'dark') {
    document.documentElement.dataset.theme = saved;
  }
}
